import { api } from '../../client';

export interface PaymentReceivedDto {
  id: string;
  customer_id: string;
  customer_name: string;
  invoice_id: string | null;
  invoice_number: string | null;
  amount: number;
  payment_date: string;
  payment_method: string;
  reference: string;
  notes: string;
  created_at?: string;
}

export const salesPaymentsReceivedApi = {
  async list(params?: {
    customer_id?: string;
    from_date?: string;
    to_date?: string;
  }): Promise<{ data?: PaymentReceivedDto[]; message?: string; errors?: Record<string, string[]> }> {
    const sp = new URLSearchParams();
    if (params?.customer_id) sp.set('customer_id', params.customer_id);
    if (params?.from_date) sp.set('from_date', params.from_date);
    if (params?.to_date) sp.set('to_date', params.to_date);
    const q = sp.toString() ? `?${sp.toString()}` : '';
    return api.get(`/sales/payments-received${q}`) as Promise<{ data: PaymentReceivedDto[] }>;
  },

  async get(id: string): Promise<{ data?: PaymentReceivedDto; message?: string }> {
    return api.get(`/sales/payments-received/${id}`) as Promise<{ data: PaymentReceivedDto }>;
  },

  async create(data: {
    customer_id: string;
    invoice_id?: string | null;
    amount: number;
    payment_date: string;
    payment_method?: string;
    reference?: string;
    notes?: string;
  }): Promise<{ data?: PaymentReceivedDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/sales/payments-received', data) as Promise<{
      data: PaymentReceivedDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async update(
    id: string,
    data: { reference?: string; notes?: string }
  ): Promise<{ data?: PaymentReceivedDto; message?: string; errors?: Record<string, string[]> }> {
    return api.put(`/sales/payments-received/${id}`, data) as Promise<{
      data: PaymentReceivedDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async delete(id: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/sales/payments-received/${id}`) as Promise<{ success?: boolean; message?: string }>;
  },
};
